/* eslint-disable import/prefer-default-export */
import { toast } from 'react-toastify';
import Api from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';
import { isEscene } from '../lib/utils';

// get Port config template by port name i.e alarmObi/alarmEscene
export const getPortConfigTemplates = (token, dc, portType, ataType,compID) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.portConfig.getPortConfigTemplates(dc, portType, ataType,compID);
    dispatch({
      type: 'PORT_CONFIG_TEMPLATES_SUCCESS',
      payload: data?.data || []
    })
    return data?.data || [];
  } catch (error) {
    dispatch({
      type: 'PORT_CONFIG_TEMPLATES_SUCCESS',
      payload: []
    })
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'getPortConfigTemplates',
    });
    return [];
  }
};

// get Port config template by port name i.e alarmObi/alarmEscene
export const getPortConfigTemplatesByPortName = (token, dc, macAddress, portType,ataType) => async dispatch => {
  const api = new Api(token);
  portType = isEscene(macAddress) ? `${portType}Escene` : `${portType}Obi`
  try {
    const data = await api.portConfig.getPortConfigTemplateByPortType(dc, portType,ataType);
    console.log("data from portconfigtemplate", data)
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'getPortConfigTemplatesByPortName',
    });
    return [];
  }
};

// set selected port config template in redux
export const setSelectedPortConfigTemplate = (selectedTemplate) => async dispatch => {
  dispatch({
    type: 'SELECTED_PORT_CONFIG_TEMPLATE_SUCCESS',
    payload: selectedTemplate
  })
};

export const addPortConfigTemplateByName = (token, body, compID, dc) => async (dispatch) => {
  const api = new Api(token);
  try {
    const data = await api.portConfig.addPortConfigTemplate(body, compID, dc);
    dispatch({
      type: 'PORT_CONFIG_TEMPLATES_SUCCESS_NAME',
      payload: data || [],
    });
    if (data?.data) {
      toast.success('Template created successfully', {
        toastId: 'addPortConfigTemplates',
      });
    }
    return data.data || [];
  } catch (error) {
    dispatch({
      type: 'PORT_CONFIG_TEMPLATES_FAILURE_NAME',
      payload: [],
    });
    toast.error(error?.response.data?.error || ERROR_MESSAGE, {
      toastId: 'addPortConfigTemplates',
    });
    return [];
  }
};
export const getAllCustomTemplates = (token, page = 1, limit = 10) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.portConfig.getAllCustomTemplates(page, limit);
    console.log('data from portconfigtemplate', data);
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'getPortConfigTemplatesByPortName',
    });
    return [];
  }
};
export const deleteCustomTemplate = (token, id) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.portConfig.deleteCustomTemplate(id);
    toast.success('Template deleted successfully');
    return data;
  } catch (error) {
    toast.error(error?.response?.data?.error || ERROR_MESSAGE);
    return null;
  }
};
export const updateCustomTemplate = (token, id, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.portConfig.updateCustomTemplate(id, body);
    toast.success('Template updated successfully');
    return data;
  } catch (error) {
    toast.error(error?.response?.data?.error || ERROR_MESSAGE);
    return null;
  }
};